import type { CustomerServiceManagementCrmImport } from '@jira/forge__forge-ui-types/src/common/types/extension.tsx';
import { CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE } from '@jira/forge__forge-ui-constants/src/constants.tsx';
import { fetchModules } from '@jira/forge__forge-ui-utils/src/utils/fetch-modules/doFetchWithGraphQLErrorsTracking.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { alphabeticalSort } from '@atlassian/jira-common-util-software-filters-sort/src/index.tsx';

export const customerServiceManagementCrmImportModuleResource: RouteResource<
	CustomerServiceManagementCrmImport[]
> = createResource<CustomerServiceManagementCrmImport[]>({
	type: 'FORGE_CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE',
	getKey: () => 'csm-crmimport-extensions',
	getData: (_routeContext, { tenantContext: { cloudId, isAnonymous } }) =>
		fetchModules({
			cloudId,
			isAnonymous,
			types: [CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE],
			context: {},
			includeHidden: true,
			source: 'crm-import',
		}).then((modules) => {
			const extensions = modules[CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE] || [];
			return extensions.sort((a, b) => alphabeticalSort(a.properties.title, b.properties.title));
		}),
	maxAge: Number.MAX_SAFE_INTEGER,
});
